import { FinancialAccount, GlobalPosition } from '@api/models';
import { ProductTypes } from '@core/constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// functions

export function isDeposit(account: FinancialAccount) {
  return (
    ProductTypes.Deposit.some((deposit) => deposit === account.ProductCode) ||
    ProductTypes.EmployeeDeposit.some((deposit) => deposit === account.ProductCode)
  );
}

export function isAccount(account: FinancialAccount) {
  return (
    ProductTypes.Account.some((accounts) => accounts === account.ProductCode) ||
    ProductTypes.EmployeeAccount.some((accounts) => accounts === account.ProductCode)
  );
}

// operators
export function findAccount() {
  return (source: Observable<GlobalPosition>) =>
    source.pipe(
      map((globalPosition) => globalPosition?.Accounts?.find((account) => isAccount(account)))
    );
}

export function findDeposit() {
  return (source: Observable<GlobalPosition>) =>
    source.pipe(
      map((globalPosition) => globalPosition?.Accounts?.filter((account) => isDeposit(account)))
    );
}

export function findKnownProducts() {
  return (source: Observable<GlobalPosition>) =>
    source.pipe(
      map((globalPosition) =>
        globalPosition?.Accounts?.filter((account) => isAccount(account) || isDeposit(account))
      )
    );
}
